import { DatePicker, Form } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { specialDoctorID } from "utils/general";

const isSafari = () =>
  typeof navigator !== "undefined" &&
  navigator.userAgent.indexOf("Safari") !== -1 &&
  navigator.userAgent.indexOf("Chrome") === -1;

export default function UltraDateFormItem({
  doctorId,
  name = "date",
  label = "Date",
  required = true,
  placeholder = "MM-DD-YYYY",
  format = "MM-DD-YYYY",
  disabledDate,
  validator,
  showToday = false,
  ...restFormProps
}) {
  const defaultDisabledDate = (current) => {
    if (!current) return true;
    const today = moment().endOf("day");
    const eighteenYearsAgo = moment().subtract(18, "years").endOf("day");
    const hundredYearsAgo = moment().subtract(100, "years").startOf("day");
    return (
      current.isAfter(eighteenYearsAgo) ||
      current.isBefore(hundredYearsAgo) ||
      current.isAfter(today)
    );
  };

  const checkDrId = (id) => id === specialDoctorID; // special doctor ID

  const defaultValidator = (_, value) => {
    if (!value) return Promise.reject("Please select your date");
    const eighteenYearsAgo = moment().subtract(18, "years").endOf("day");
    if (value.isSameOrBefore(eighteenYearsAgo)) {
      return Promise.resolve();
    }
    return Promise.reject("Must be 18 or older!");
  };

  // 🔹 State to control picker default date
  const [pickerValue, setPickerValue] = useState(
    checkDrId(doctorId)
      ? moment() // special doctor → today
      : moment().subtract(18, "years").startOf("day")
  );

  // 🔹 Update pickerValue whenever doctorId changes
  useEffect(() => {
    setPickerValue(
      checkDrId(doctorId)
        ? moment()
        : moment().subtract(18, "years").startOf("day")
    );
  }, [doctorId]);

  return (
    <Form.Item
      label={label}
      name={name}
      validateFirst
      rules={[
        {
          required,
          message: `Please select your ${label.toLowerCase()}`,
        },
        ...(checkDrId(doctorId) || isSafari()
          ? []
          : [{ validator: validator || defaultValidator }]),
      ]}
      {...restFormProps}
    >
      <DatePicker
        key={doctorId} // 🔹 Force re-mount when doctor changes
        disabledDate={checkDrId(doctorId) ? disabledDate : defaultDisabledDate}
        style={{ width: "100%" }}
        format={format}
        placeholder={placeholder}
        defaultPickerValue={pickerValue} // 🔹 dynamic based on doctor
        onChange={(value) => setPickerValue(value)}
        showToday={showToday}
      />
    </Form.Item>
  );
}
